<div class="rounded-2xl border border-neutral-a4 bg-neutral-a2 p-6 flex flex-col gap-4 shadow-2xs">
  <div class="flex items-start gap-4">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
      <span class="material-icons text-xl text-primary">receipt_long</span>
    </div>
    <div class="min-w-0 flex-1">
      <h3 class="text-base font-bold text-neutral-12">Méthodes de paiement & Historique de facturation</h3>
      <div class="mt-1 text-sm text-neutral-11 whitespace-normal leading-relaxed">
        Consultez l'historique de vos transactions, téléchargez vos factures et reçus de paiement au format
        PDF, et modifiez vos coordonnées de facturation ou vos cartes enregistrées.
      </div>
    </div>
  </div>

  <div class="flex justify-end mt-2">
    @if (loadingPortal()) {
      <button mat-flat-button class="primary" disabled>
        <mat-spinner diameter="18" strokeWidth="2.5" class="mr-2 inline-block"></mat-spinner>
        Connexion en cours...
      </button>
    } @else {
      <button mat-flat-button class="primary" (click)="manage.emit()">
        <span class="material-icons mr-1.5 text-sm">open_in_new</span>
        Accéder à mon portail Stripe
      </button>
    }
  </div>
</div>
